import {API, graphqlOperation} from "aws-amplify";
import {listContacts, getProfile, inviteContact, updateProfile, listActivities} from "./graphql";
import {GraphQLResult} from "@aws-amplify/api-graphql";
import ContactDto, {ContactServerResponseDto, InputContact} from "./ContactDto";
import {DataServices, DataServices as Ds} from "./DataServices";
import StackDto from "./StackDto";
import Amplify, { Storage } from 'aws-amplify';
import awsconfig from '../../shared/data-services/aws-exports';

class ContactsService {
    private contactsByActivityId: Record<string, ContactDto[]> = {};
    private profileContact: ContactDto | null = null;
    private lastActionResponseMessages: any[] = [];
    constructor() {}

    allLoaded() {
        return true;
    }

    clearCache() {
        this.contactsByActivityId = {};
    }

    async getProfile() {
        //if (!this.profileContact) {
            await this.loadCompanyProfile();
        //}
        return this.profileContact ?? null;
    }

    getLoadedContactsForCurrentActivity(): ContactDto[] {
        const activeActivityId = Ds.ActivitiesService.getActiveActivityId();
        return this.contactsByActivityId[activeActivityId] ?? [];
    }

    getLoadedContactById(contactId: string): ContactDto | null {
        for (const contactList of Object.values(this.contactsByActivityId)) {
            const foundContact = contactList.find(card => card.id === contactId);
            if (foundContact) {
                return foundContact;
            }
        }
        return null;
    }

    async getContactsForCurrentActivity(): Promise<ContactDto[]> {
        const activeActivityId = Ds.ActivitiesService.getActiveActivityId();
        return this.getContactsForActivity(activeActivityId);
    }

    async getContactsForActivity(activityId: string): Promise<ContactDto[]> {
        if (!this.contactsByActivityId[activityId]) {
            await this.loadContactsForActivity(activityId);
        }
        return [...this.contactsByActivityId[activityId]];
    }

    async inviteContact(newContact: InputContact) {
        try {
            return API.graphql(graphqlOperation(inviteContact, {
                activityId: DataServices.ActivitiesService.getActiveActivityId(),
                email: newContact.email,
            }));
        } catch (err) {
            return err;
        }
    }

    async deleteContact(contactId: string) {
        //TODO
    }

    async removeContactFromActivity(activityId: string, contactId: string) {
        //TODO
    }

    async updateAvatar(contactId, localUri) : Promise<any> {
        try {
            const result = await Storage.put(contactId, localUri);
            const resultProfile = await this.updateProfile(null, { key: 'public/' + contactId });
            console.log(resultProfile);
            return result;
        }catch (e) {
            return e;
        }
    }

    getMyAvatar() : any {
        try {
            const result = 'https://' +
                awsconfig.aws_content_delivery_bucket +
                '.s3.' +
                awsconfig.aws_content_delivery_bucket_region +
                '.amazonaws.com/public/'
                + this.profileContact?.id + 
                '?' + this.profileContact.updatedAt;
            return result;
        }catch (e) {
            return e;
        }
    }

    getAvatar(contactId, updatedAt) : any {
        try {
            const result = 'https://' +
                awsconfig.aws_content_delivery_bucket +
                '.s3.' +
                awsconfig.aws_content_delivery_bucket_region +
                '.amazonaws.com/public/'
                + contactId + 
                '?' + updatedAt;
            return result;
        }catch (e) {
            return e;
        }
    }

    getResponseMessages() {
        return this.lastActionResponseMessages.slice();
    }

    clearResponseMessages() {
        this.lastActionResponseMessages = [];
    }

    private async loadCompanyProfile() {
        const result = (await API.graphql(graphqlOperation(getProfile))) as GraphQLResult<any>;
        if (result.data?.getProfile) {
            this.profileContact = this.serverDataToInternalDto(result.data.getProfile);
        }
        else {
            this.profileContact = null;
        }
    }

    async updateProfile(name: string, file: any) {
        const result = (await API.graphql(graphqlOperation(updateProfile, {name, file }))) as GraphQLResult<any>;
        return result.data?.updateProfile;
    }

    private serverDataToInternalDto(contactResponseObject: ContactServerResponseDto): ContactDto {
        const contact = {
            id: contactResponseObject.id,
            name: contactResponseObject.name,
            updatedAt: contactResponseObject.updatedAt
        };
        const parsedAppendix = JSON.parse(contactResponseObject.appendix)
        Object.assign(contact, parsedAppendix);
        return contact as ContactDto;
    }

    async listAllContacts() {
        const result = (await API.graphql(graphqlOperation(listActivities))) as GraphQLResult<any>;
        const currentContacts = [];
        if (result.data.listActivities.items) {
            result.data.listActivities.items.forEach(act => {
                act.contacts.items.forEach(con => {
                    if (!currentContacts.some(c => c.id === con.id))
                        currentContacts.push(this.serverDataToInternalDto(con));
                });
            });
        }
        return currentContacts;
    }

    private async loadContactsForActivity(activityId: string) {
        const result = (await API.graphql(graphqlOperation(listContacts, { activityId }))) as GraphQLResult<any>;
        if (result.data.listContacts) {
            console.log(result.data.listContacts);
            this.contactsByActivityId[activityId] = [];
            for (const contact of result.data.listContacts.items) {
                this.contactsByActivityId[activityId].push(this.serverDataToInternalDto(contact));
            }
        }
    }
}

export default ContactsService;